import React from "react";
import studentIcon from "../../assets/image/student.png";
import freshersIcon from "../../assets/image/freshers.png";
import professionalsIcon from "../../assets/image/professionals.png";

function Opportunity() {
  return (
    <>
      <div className="opportunity-section">
        <div className="container text-center">
          <h4 className="text-uppercase">
            Discover if this is the perfect fit for your journey
          </h4>
          <h2 className="mt-3 mb-5">Who Should Seize the Opportunity?</h2>
          <div className="row">
            <div className="col-md-4">
              <div className="card">
                <div className="card-body">
                  <img src={studentIcon} alt="Student" className="card-icon mb-3" />
                  <h5 className="card-title">Students</h5>
                  <p className="card-text">
                    Build a strong foundation in tech or design. Ideal to start in the 2nd or 3rd year of your
                    college course to prepare for internships and jobs.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card">
                <div className="card-body">
                  <img src={freshersIcon} alt="Fresher" className="card-icon mb-3" />
                  <h5 className="card-title">Freshers</h5>
                  <p className="card-text">
                    Fresh graduates with zero industry experience can jumpstart their tech
                    journey and build a strong professional portfolio.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card">
                <div className="card-body">
                  <img src={professionalsIcon} alt="Professional" className="card-icon mb-3" />
                  <h5 className="card-title">Working Professionals</h5>
                  <p className="card-text">
                    Early-career professionals looking to upskill, transition fields, 
                    or deepen their engineering and design capabilities.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Opportunity;
